import React from "react";
import "../Guides/guides.css";
import Seo from "../Seo.jsx";
import mainConfig from "../../config/mainConfig";

const AffiliateDisclosure = () => {
  const meta = mainConfig.affiliateDisclosure?.seo || {};

  return (
    <div className="guides-content guides-content-pad">
                   <Seo title={meta.title} description={meta.description} url={meta.route}/>

        <h1>Affiliate Disclosure</h1>
        <p>We're proud to partner with brands and services that we genuinely believe in—and that we think you'll love too. When you click on some of the links throughout our site and make a purchase, we may earn a small commission at no extra cost to you.</p>
        <p>We carefully choose our partners and only recommend products and services we trust to deliver real value for you, our readers. Your trust is our top priority, and we'll always put your interests first.</p>
        <p>Thanks for supporting us and helping us continue to bring you great content!</p>

    </div>
  );
};

export default AffiliateDisclosure;